export class TipoEnvio {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string,
    public readonly Nombre: string,
    public readonly Comentario: string,
    public readonly MontoTopeMinimo: number | null,
    public readonly MontoTopeMaximo: number | null,
    public readonly CondicionAplicacionImpuestos: number,
    public readonly CondicionAplicacionImpuestosNombre: string,
    public readonly VariableCalculoIva: number,
    public readonly VariableCalculoIvaNombre: string,
    public readonly VariableCalculoIvaExcedente: number | null,
    public readonly VariableCalculoIvaExcedenteNombre: string,
    public readonly Activo: boolean
  ) {}
}

export class SearchTipoEnvioRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string,
    public readonly Codigo: string | null,
    public readonly Nombre: string | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}
export class SaveTipoEnvioDto {
  constructor(
    public readonly Codigo: string,
    public readonly Nombre: string,
    public readonly Comentario: string,
    public readonly MontoTopeMinimo: number | null,
    public readonly MontoTopeMaximo: number | null,
    public readonly CondicionAplicacionImpuestos: number,
    public readonly VariableCalculoIva: number,
    public readonly VariableCalculoIvaExcedente: number | null,
    public Activo: boolean
  ) {}
}

export class SearchTipoEnvioResponse {
  constructor(
    public readonly count: number,
    public readonly result: TipoEnvio[]
  ) {}
}

export class TipoEnvioList {
  constructor(
  public readonly Id: number,
  public readonly Nombre: string,
  public readonly Comentario: string,
  ) {}
}
